import Button from '@mui/material/Button';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { apiAuth } from '../resources/api/apiAuth';
import { useEnumState } from '../hooks/useEnumState';
import { useApiErrorHandler } from '../hooks/useApiErrorHandler';
import { AuthDialog } from '../components/AuthDialog/AuthDialog';
import { TypographyBody1 } from '../components/Typography/Typography';
import { useAuth } from '../hooks/useAuth';

const { useSendEmailVerificationCode } = apiAuth;

export const UnverifiedAccountPage = () => {
  const { t } = useTranslation();
  const [sent, setSent] = useEnumState(false, true);
  const handleError = useApiErrorHandler();
  const { logOut } = useAuth();

  const { execute } = useSendEmailVerificationCode();

  const onSend = useCallback(async () => {
    try {
      await execute();
      setSent();
    } catch (e) {
      handleError(e);
    }
  }, [execute]);

  return (
    <AuthDialog
      title={t('auth.unverified.title')}
      actions={[
        <Button key="cancel" variant="outlined" onClick={logOut}>
          {t('auth.unverified.logout')}
        </Button>,
        <Button key="send" variant="contained" color="primary" onClick={onSend}>
          {t('auth.unverified.submit')}
        </Button>,
      ]}
    >
      <TypographyBody1>{sent ? t('auth.unverified.sent') : t('auth.unverified.text')}</TypographyBody1>
    </AuthDialog>
  );
};
